// AUTH
export const AUTH_SET_TOKEN = "AUTH_SET_TOKEN";
export const AUTH_DEL_TOKEN = "AUTH_DEL_TOKEN";
export const AUTH_SET_REMEMBER_ME = "AUTH_SET_REMEMBER_ME";
export const AUTH_DEL_REMEMBER_ME = "AUTH_DEL_REMEMBER_ME";
export const AUTH_SET_LOCALE = "AUTH_SET_LOCALE";
export const AUTH_RESET_LOCALE = "AUTH_RESET_LOCALE";
export const AUTH_START_REFRESH = "AUTH_START_REFRESH";
export const AUTH_END_REFRESH = "AUTH_END_REFRESH";

// ACCOUNT
export const ACCOUNT_SET_DATAS = "SET_ACCOUNT_DATAS";
export const ACCOUNT_SET_DELIVERY_ADDRESS = "ACCOUNT_SET_DELIVERY_ADDRESS";
export const ACCOUNT_DEL_DATAS = "DEL_ACCOUNT_DATAS";
export const SET_ACCOUNT_FILTERS = "SET_ACCOUNT_FILTERS";
export const RESET_ACCOUNT_FILTERS = "RESET_ACCOUNT_FILTERS";

// CREATE ACCOUNT
export const CREATE_ACCOUNT_UPD_INFO = "CREATE_ACCOUNT_UPD_INFO";
export const CREATE_ACCOUNT_DEL_INFO = "CREATE_ACCOUNT_DEL_INFO";

// NAVIGATION
export const NAVIGATION_SET_PATH = "NAVIGATION_SET_PATH";
export const NAVIGATION_SET_PATHBRAND = "NAVIGATION_SET_PATHBRAND";

// SCORM
export const SET_SCORM = "SET_SCORM";
export const REFRESH_SCORM = "REFRESH_SCORM";

//WALL
export const SET_FILTERS = "SET_FILTERS";
export const RESET_FILTERS = "RESET_FILTERS";
export const SET_DATA = "SET_DATA";

export const SET_CONFIG = "SET_CONFIG";
export const SET_SHOP_CONFIG = "SET_SHOP_CONFIG";
export const RESET_CONFIG = "RESET_CONFIG";

// STORE
export const SET_PRODUCTS = "SET_PRODUCTS";
export const SET_CATEGORIES = "SET_CATEGORIES";
export const SET_CART = "SET_CART";
export const SET_OPEN = "SET_OPEN";
export const RESET_STORE = "RESET_STORE";
export const SET_ADDRESS = "SET_ADDRESS";
export const RESET_ADDRESS = "RESET_ADDRESS";

// HP (News)
export const SET_ITEMS = "SET_ITEMS";
export const RESET_ITEMS = "RESET_ITEMS";

// Brands
export const SET_BRANDS = "SET_BRANDS";
export const RESET_BRANDS = "RESET_BRANDS";
export const SHOW_LINEAR_BRANDS = "SHOW_LINEAR_BRANDS";

// Formations
export const SET_FORMATIONS = "SET_FORMATIONS";
export const RESET_FORMATIONS = "RESET_FORMATIONS";

//SEARCH
export const SET_SEARCH_FILTERS = "SET_SEARCH_FILTERS";
export const RESET_SEARCH_FILTERS = "RESET_SEARCH_FILTERS";

// NOTIFICATIONS
export const SET_NOTIFICATIONS = "SET_NOTIFICATIONS"

//INTERSTITIAL
export const SET_INTERSTITIALS = "SET_INTERSTITIALS"

// Préférences
export const SET_ACTIVE_GROUPS = "SET_ACTIVE_GROUPS"
